<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only">
    <v-combobox
      :id="id"
      v-model="model"
      :search-input.sync="search"
      :label="label"
      :prepend-icon="prepend_icon"
      :append-icon="append_icon"
      :item-text="item_key"
      :item-value="item_key"
      clearable
      multiple
      chips
      small-chips
      deletable-chips
      hide-selected
      v-on:change="change_m"
      :items="string_items"
      no-filter>
        <template v-slot:append-item>
          <div v-intersect="endIntersect"></div>
        </template>
    </v-combobox>
    <inf_scroll
      v-if="checked_get"
      :is_intersecting="is_intersecting"
      :m_search="search"
      :main_rq_name="name_all_computed"
      :name="`inf-${name}`"
      :ex_filters="ex_filters"
      :items.sync="items" />
    <main_combobox_rq :value.sync="main_model" :name="main_name" :f_key="main_f_key" :item_key="item_key"/>
  </pre_input>
</template>

<script>
import pre_input_js from '@/components/mixins/pre_input';
import Debounce from '@/components/Debounce';
import filter_rq from './filter_rq';
import main_combobox_rq from './main-combobox-rq';
import inf_scroll_js from './inf_scroll.js';

import {v4 as uuid} from 'uuid';

export default {
  props:{
    main_f_key:{},
    main_name:{},/* name se usara para actualizar la lista , ya que el proceso que hace debounce y otros procesos usan ese atr */
    f_key:{},
    items_on_search:{default:true},
    reset_on_value_change:{default:false},//uso normal usa los datos previos, pero para modals de editar y/o crear, se necesitan limpios o con la info de es reg y no la anterior
    multiple:{default:false},
    ints:{default:false}
  },
  mixins: [ filter_rq, Debounce, pre_input_js, inf_scroll_js  ],
  components:{main_combobox_rq},
  data(){
    return {
      id: uuid(),
      main_model:null,
      model: null,
      items: [],
      filter_rq_type:['<','>'],
      /* string_items:[], */

      main_request_status:{
        rq: false,
        status: false,
        ticking: false,
        active: false,
        name: null, 
        message:null,
        fp: null,
        slot_key:null,
        filter:{},
        last_key_filterd:null,
        default:true,
      },
      main_filter:{},
    }
  },
  computed: {
    k_f(){ return this.f_key || `s__${this.item_key}` },
        /* si la lista tiene numero y es tipo numero, search-input da error*/
    string_items(){  
      const l = this.items.map(m=>{ return typeof m == 'object'? {...m}:m});
      return this.items_on_search && this.search?l.map(m => (m[this.item_key] = m[this.item_key]+'') && m): []
    },

    main_request_status_filter() {
      if (!this.main_request_status) return null;
      if(this.main_request_status.filter === undefined) {
        console.error('no se definieron filtro en config.js');
        this.main_request_status.filter = {};
      }
      return this.main_request_status.filter;
    },
  },
  watch: {
    'search'(v,v_old){
      if (v === null && v_old === null) return;// valor xdef es null asi evita la primera carga
      this.debounceM('search', ()=>this.dev_log({v,v_old}) || this.aa() || this.searchM(v,v_old));
    },
    'main_model'(v,v_old){
      this.$emit('update:value', v);
    },
  },
  created(){
    this.debounce_t['change_m'] = 150;
    this.main_model = this.value;
    this.main_request_status = this.requestStatus.find(r => r.name == `${this.main_name}/a/all`);
  },
  mounted(){
    document.getElementById(this.id).addEventListener('paste', this.onPaste, { })
  },
  methods: {
     onPaste (evt) {
      const pastedData = (evt.clipboardData || window.clipboardData).getData('Text').split('\r\n');
      pastedData.unshift((this.search||'').trim());

      evt.stopPropagation();
      evt.preventDefault();

      this.search = '';
      this.change_m([...this.model||[]].concat(pastedData.filter(f=>f)))
    },
    aa(){
      this.main_filter = {};
      const ks = Object.keys(this.main_request_status_filter).filter(k=> !['page','count','page_size','pages'].find(f=>f==k) && k)
      ks.forEach(k=>this.main_filter[k] = this.main_request_status_filter[k]);
      //console.log(parse_filters(this.main_filter));
      Object.assign(this.myRequestStatus_filter,this.main_filter)
    },
    change_m(items){
      const p_items = items.length && this.ints? items.filter(v=>!isNaN(v)):items||[];
      this.model = this.multiple ? p_items : (p_items.length ? [p_items[p_items.length-1]] : []);
      const fnt = ()=> this.main_model = this.model;
      this.debounceM('change_m', fnt);
    },
    set_model(only_cache) {// en este caso solo actualiza la lista
      if (only_cache) {
        if (this.value) this.model = this.value;
      } else {
        if (this.value_key) {    
          return console.error('codigo faltante');  
        } else {
          const ex_f = {}[this.k_f] = this.search;
          this.get_rq(ex_f,only_cache);
        } 
      }
    },
    then_get_rows(r) {
      if (this.values(this.myRequestStatus_filter)) this.items = (((r || {}).results || r) || []);
      return r;
    },
    upd(){console.error('!x!');},
  },
};
</script>
